import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { params } from "../../vars/params";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export const para = (): void => {
  let smoother: ScrollSmoother | null = null;
  if (!params.isSp) {
    smoother = ScrollSmoother.create({
      smooth: 3,
      effects: true,
      smoothTouch: 0.01,
    });

    gsap.utils.toArray<HTMLAnchorElement>("a[href*='#']").forEach(function (button) {
      button.addEventListener("click", (e) => {
        const href = button.getAttribute("href");
        if (!href) {
          return;
        }

        // Extract path and hash from href
        const hashIndex = href.indexOf("#");
        if (hashIndex === -1) {
          return;
        }

        const path = href.substring(0, hashIndex) || window.location.pathname;
        const id = href.substring(hashIndex + 1);
        const currentPath = window.location.pathname;

        // Normalize paths (remove trailing slashes for comparison)
        const normalizePath = (p: string) => p.replace(/\/$/, "") || "/";
        const normalizedPath = normalizePath(path);
        const normalizedCurrentPath = normalizePath(currentPath);

        // Check if the link is to a different page
        if (normalizedPath !== normalizedCurrentPath && path !== "") {
          // Navigate to different page
          console.log("Navigating to different page:", href);
          window.location.href = href;
          return;
        }

        // Same page - scroll to element
        e.preventDefault();
        const targetElement = document.getElementById(id);

        if (targetElement) {
          console.log("Scrolling to id:", id);
          if (smoother) {
            smoother.scrollTo(targetElement, true, "top 20%");
          } else {
            // Fallback for mobile
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        } else {
          console.warn("Target element not found for id:", id);
        }
      });
    });
  } else {
    gsap.utils.toArray<HTMLAnchorElement>("a[href*='#']").forEach(function (button) {
      button.addEventListener("click", (e) => {
        const href = button.getAttribute("href");
        if (!href) {
          return;
        }

        // Extract path and hash from href
        const hashIndex = href.indexOf("#");
        if (hashIndex === -1) {
          return;
        }

        const path = href.substring(0, hashIndex) || window.location.pathname;
        const id = href.substring(hashIndex + 1);
        const currentPath = window.location.pathname;

        // Normalize paths (remove trailing slashes for comparison)
        const normalizePath = (p: string) => p.replace(/\/$/, "") || "/";
        const normalizedPath = normalizePath(path);
        const normalizedCurrentPath = normalizePath(currentPath);

        // Check if the link is to a different page
        if (normalizedPath !== normalizedCurrentPath && path !== "") {
          // Navigate to different page
          console.log("Navigating to different page:", href);
          window.location.href = href;
          return;
        }

        // Same page - scroll to element
        e.preventDefault();
        const targetElement = document.getElementById(id);

        if (targetElement) {
          console.log("Scrolling to id:", id);
          // Fallback for mobile
          gsap.to(window, { scrollTo: { y: targetElement.id, offsetY: 80 }, duration: 0.5, ease: "power2.out" });
        } else {
          console.warn("Target element not found for id:", id);
        }
      });
    });
  }

  // gsap.utils.toArray(".nav a").forEach(function (button, i) {
  //   button.addEventListener("click", (e) => {
  //     var id = e.target.getAttribute("href");
  //     console.log(id);
  //     smoother.scrollTo(id, true, "top top");
  //     e.preventDefault();
  //   });
  // });

  // let urlHash = window.location.href.split("#")[1];

  // let scrollElem = document.querySelector("#" + urlHash);

  // console.log(scrollElem, urlHash);

  // if (urlHash && scrollElem) {
  //   gsap.to(smoother, {
  //     scrollTop: smoother.offset(scrollElem, "top top"),
  //     duration: 1,
  //     delay: 0.5,
  //   });
  // }

  const paraBgs = document.querySelectorAll(".c-para-bg");
  const paraAnimConts = document.querySelectorAll(".c-anim-cont");
  paraBgs.forEach((paraBg) => {
    gsap.to(paraBg.querySelector(".c-para-bg__bg"), {
      top: "0%",
      scrollTrigger: {
        trigger: paraBg,
        start: "top 100%",
        end: "bottom 0%",
        scrub: true,
      },
    });
  });
  paraAnimConts.forEach((paraAnimCont) => {});

  const paraDepths = document.querySelectorAll("[data-para-depth]");
  const depthImpact = params.bH * 0.05;
  paraDepths.forEach((paraDepth) => {
    console.log(paraDepth);
    const depth = parseFloat((paraDepth as HTMLElement).dataset.paraDepth || "0") || 0;
    gsap.fromTo(
      paraDepth.querySelector("*"),
      {
        y: -1 * depthImpact * depth,
      },
      {
        y: 1 * depthImpact * depth,
        duration: 1,
        ease: "none",
        scrollTrigger: {
          trigger: paraDepth,
          start: "top 100%",
          end: "bottom 0%",
          scrub: 1,
        },
      }
    );
  });
  gsap.to(".p-top-space__img-inner", {
    scale: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".p-top-space__img",
      start: "top 100%",
      end: "bottom 0%",
      scrub: 1,
    },
  });
};
